module.exports = __webpack_public_path__ + "img/order-step3-b.533ec7a6.png";